import React from 'react';
import { Project } from '../../services/AxiosServices';
import './MedicalDossierSelector.css';

interface MedicalDossierSelectorProps {
  selectedProjectId?: string;
  projects: Project[];
  onProjectChange?: (projectId: string) => void;
}

const MedicalDossierSelector: React.FC<MedicalDossierSelectorProps> = ({ selectedProjectId, projects, onProjectChange }) => {
  const handleProjectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newProjectId = e.target.value;
    if (onProjectChange) {
      onProjectChange(newProjectId);
    }
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      {projects.length > 0 && (
        <select 
          value={selectedProjectId}
          onChange={handleProjectChange}
          className="medical-dossier-selector"
        >
          {projects.map(p => (
            <option key={p.project_id} value={p.project_id}>{p.name}</option>
          ))}
        </select>
      )}
      <svg 
        width="14" 
        height="14" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="3" 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        style={{ 
          color: '#94a3b8', 
          position: 'absolute', 
          right: '12px', 
          top: '50%', 
          transform: 'translateY(-50%)',
          pointerEvents: 'none' 
        }}
      >
        <polyline points="6 9 12 15 18 9"></polyline>
      </svg>
    </div>
  );
};

export default MedicalDossierSelector;
